import { useEffect, useState } from "react";
import axios from "axios";
import DoctorCard from "../components/DoctorCard";
import { doctors } from "./doctors._data";

export default function Doctors() {
  // const [doctors, setDoctors] = useState([]);
  // const [loading, setLoading] = useState(true);
  const loading = false;
  // useEffect(() => {
  //   const fetchDoctors = async () => {
  //     try {
  //       const response = await axios.get(`${API}/doctors`);
  //       setDoctors(response.data);
  //     } catch (error) {
  //       console.error('Error fetching doctors:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchDoctors();
  // }, []);

  return (
    <div className="min-h-screen py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1
            className="text-5xl md:text-6xl font-heading font-bold text-[#2D3436] mb-4"
            data-testid="doctors-page-title"
          >
            Our Expert <span className="text-primary">Doctors</span>
          </h1>
          <p className="text-lg text-[#636E72] max-w-3xl mx-auto">
            Meet our team of certified Ayurvedic physicians dedicated to your
            holistic health and wellness
          </p>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <div className="inline-block w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          <div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
            data-testid="doctors-grid"
          >
            {doctors.map((doctor) => (
              <DoctorCard key={doctor.id} doctor={doctor} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
